import { FC, useEffect, useState } from 'react';

import PrivateRoute from 'components/private-route/PrivateRoute';
import Home from 'pages';
import AdminSearch from 'pages/admin';
import Authentication from 'pages/authentication';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import appRoutes from 'utils/routes';

const AppRoutes: FC = () => {
    const { boot, update } = useIntercom();

    useEffect(() => {
        boot();
    }, [boot]);

    const location = useLocation();

    const [lastPathname, setLastPathname] = useState(location.pathname);

    useEffect(() => {
        if (lastPathname !== location.pathname) {
            update();
            setLastPathname(location.pathname);
        }
    }, [lastPathname, location.pathname, update]);

    return (
        <Switch>
            <Route path={appRoutes.auth.root}>
                <Authentication />
            </Route>
            <PrivateRoute
                allowedGroups={['ServicingAgent']}
                path={appRoutes.admin.root}
            >
                <AdminSearch />
            </PrivateRoute>

            <PrivateRoute path={appRoutes.home.root}>
                <Home />
            </PrivateRoute>
            <Route path={appRoutes.notFound.root}>
                <Redirect to={appRoutes.home.root} />
            </Route>
        </Switch>
    );
};

export default AppRoutes;
